export class LookupOptionDto {
    Id: number;
    Name: string;
}